import { ListProps, default as MuiList } from '@mui/material/List'

const List = (props: ListProps) => {
  return <MuiList {...props} />
}

export default List
